export default "__VITE_ASSET__d5bdee7c__"